import React from "react";
import styled from "styled-components";
import { withProps } from "recompose";
import NavLink from "react-router-dom/NavLink";

import Button from "../../components/Button";
import { get, mixin } from "../../style/util";

export var Play = styled.section.withConfig({
  componentId: "s14gjarn-0"
})(["display:flex;align-items:stretch;flex-direction:column;justify-content:stretch;height:100%;width:100%;"]);

export var CheckPanel = styled.div.withConfig({
  componentId: "s14gjarn-1"
})(["align-items:center;display:flex;flex-direction:column;justify-content:space-around;flex:1;height:100%;padding-bottom:75px;"]);
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Play/style.js
// module id = 432
// module chunks = 0